<template>
  <div id="enterPurchaseReturnOrder">
    <el-row>
      <el-button size="medium" @click="addProductVisible = true">添加产品</el-button>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码" min-width="80"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="80"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="BATCH" label="批次" min-width="70"></el-table-column>
          <el-table-column prop="LOCATION_CODE" label="库位" min-width="45"></el-table-column>
          <el-table-column prop="PRODUCTION_DATE" label="生产日期" min-width="70"></el-table-column>
          <el-table-column prop="IN_WAREHOUSE_DATE" label="入库日期" min-width="70"></el-table-column>
          <el-table-column prop="SUPPLIER_NAME" label="供应商" min-width="70"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="剩余库存" min-width="50"></el-table-column>
          <el-table-column prop="RETURN_COUNT" label="退货数量" min-width="50">
            <template slot-scope="scope">
              <el-input v-model="scope.row.RETURN_COUNT" @change="checkReturnCount(scope.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="PRODUCT_PRICE" label="库存单价" min-width="70"></el-table-column>
          <el-table-column prop="RETURN_REASON" label="退货理由" min-width="70">
            <template slot-scope="scope">
              <el-input v-model="scope.row.RETURN_REASON"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="deselect(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <tooltip-button :disabled="tableDataCompleted" tipContent="表格为空或有产品退货数量填写不正确" buttonText="确认提交" @click="submitOrder" style="float: right;">
      </tooltip-button>
    </el-row>
    <el-dialog title="添加退货产品" center :visible.sync="addProductVisible" width="1400px" :close-on-click-modal="false" top="2%">
      <el-row>
        <el-form :model="addProductForm" ref="addProductForm" size="small" class="el-form--label-justify" inline :label-width="formLabelWidth">
          <el-form-item label="产品编码：" prop="PRODUCT_CODE">
            <el-input v-model="addProductForm.PRODUCT_CODE" @keyup.enter.native="handleSearch" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品名称：" prop="PRODUCT_NAME">
            <el-input v-model="addProductForm.PRODUCT_NAME" @keyup.enter.native="handleSearch" clearable></el-input>
          </el-form-item>
          <el-form-item label="库位：" prop="LOCATION_CODE">
            <el-select v-model="addProductForm.LOCATION_CODE" clearable>
              <el-option v-for="item in positionList" :key="item.ID" :value="item.CODE" :label="item.CODE">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="生产日期：" prop="PRODUCTION_DATE" clearable>
            <el-date-picker v-model="addProductForm.PRODUCTION_DATE" type="date" value-format="yyyy-MM-dd" clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="btn" @click="handleSearch" v-preventReClick>筛选</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row>
        <el-table :data="addProductData" stripe border style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码" min-width="80"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="80"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="BATCH" label="批次" min-width="70"></el-table-column>
          <el-table-column prop="LOCATION_CODE" label="库位" min-width="45"></el-table-column>
          <el-table-column prop="PRODUCTION_DATE" label="生产日期" min-width="70"></el-table-column>
          <el-table-column prop="IN_WAREHOUSE_DATE" label="入库日期" min-width="70"></el-table-column>
          <el-table-column prop="SUPPLIER_NAME" label="供应商" min-width="70"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="剩余库存" min-width="50"></el-table-column>
          <el-table-column prop="RETURN_COUNT" label="退货数量" min-width="50">
            <template slot-scope="scope">
              <el-input v-model="scope.row.RETURN_COUNT" :disabled="scope.row.IS_ADDED" @change="checkReturnCount(scope.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="PRODUCT_PRICE" label="库存单价" min-width="70"></el-table-column>
          <el-table-column prop="RETURN_REASON" label="退货理由" min-width="70">
            <template slot-scope="scope">
              <el-input v-model="scope.row.RETURN_REASON" :disabled="scope.row.IS_ADDED"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <tooltip-button :disabled="Boolean(!(scope.row.IS_ADDED || !scope.row.SUPPLIER_ID || !scope.row.HAVE_RELATION))"
                :tipContent="scope.row.SUPPLIER_ID ? (scope.row.HAVE_RELATION ? '该产品已添加' : '当前无供应关系') : '该产品查询不到供应商'" buttonSize="small"
                buttonType="text" buttonText="添加" @click="addProduct(scope.row)">
              </tooltip-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <div class="pagination_box" style="text-align: right">
        <el-pagination @current-change="queryStockList" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addProductVisible = false" v-preventReClick>确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { queryPosition, queryWarehouseFun } from 'api/warehouseManager';
import http from '@/assets/common/http';
import util from '@/assets/common/util';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      tableData: [],
      addProductForm: {},
      formLabelWidth: '',
      addProductData: [],
      addProductVisible: false,
      positionList: [],
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
      totalCount: 0,
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      currentPage: 1,
    };
  },
  created() {
    this.queryPostionList();
  },
  computed: {
    tableDataCompleted() {
      return Boolean(this.tableData.length) && this.tableData.every((item) => (
        util.JudgmentUnit(item.TYPE_UNIT)
          ? validation.数量正数验证(item.RETURN_COUNT)
          : validation.数量整数正数验证(item.RETURN_COUNT)
      ) && (
        Number(item.RETURN_COUNT) <= Number(item.PRODUCT_COUNT)
      ));
    },
  },
  watch: {
    tableData() {
      this.addProductData = this.addProductData.map((item) => ({
        ...item,
        IS_ADDED: Boolean(this.tableData.find(({ UNIQUE_KEY }) => UNIQUE_KEY == item.UNIQUE_KEY)),
      }));
    },
  },
  methods: {
    handleSearch() {
      this.currentPage = 1;
      this.queryStockList();
    },
    async queryStockList() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SHOW: 0,
        FLAG: 0,
        WAREHOUSE_MODE: this.WAREHOUSE_MODE,
      };
      if (this.addProductForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.addProductForm.PRODUCT_NAME;
      }
      if (this.addProductForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.addProductForm.PRODUCT_CODE;
      }
      if (this.addProductForm.LOCATION_CODE) {
        params.LOCATION_CODE = this.addProductForm.LOCATION_CODE;
      }
      if (this.addProductForm.PRODUCTION_DATE) {
        params.PRODUCTION_DATE = this.addProductForm.PRODUCTION_DATE;
      }
      let tempList = [];
      await queryWarehouseFun(params).then((result) => {
        if (result.length !== 0) {
          this.totalCount = result[0].TOTAL_COUNT;
          tempList = result[0].OP_ROLE;
        } else {
          tempList = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
      for (const [index, { PRODUCT_CODE, BATCH, LOCATION_ID }] of tempList.entries()) {
        const params2 = {
          SERVICE_ID: '10057',
          OTYPE: 5,
          GYS_ID: Number(sessionStorage.getItem('tcId')),
          BATCH,
        };
        // eslint-disable-next-line no-await-in-loop, no-loop-func
        await http.post(params2).then((res) => {
          tempList[index] = {
            ...tempList[index],
            ...res[0],
            RETURN_REASON: '',
            UNIQUE_KEY: `${PRODUCT_CODE}-${BATCH}-${LOCATION_ID}`,
          };
          tempList[index] = {
            ...tempList[index],
            IS_ADDED: Boolean(this.tableData.find(({ UNIQUE_KEY }) => UNIQUE_KEY == tempList[index].UNIQUE_KEY)),
          };
        }).catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
      }
      this.addProductData = util.deepCopy(tempList);
    },
    queryPostionList() {
      queryPosition().then((result) => {
        this.positionList = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    addProduct(row) {
      if (util.JudgmentUnit(row.TYPE_UNIT)) {
        if (!validation.数量正数验证(row.RETURN_COUNT)) {
          this.$message.show({ text: '请输入正确的退货数量', type: 'warning' });
          return;
        }
      } else {
        if (!validation.数量整数正数验证(row.RETURN_COUNT)) {
          this.$message.show({ text: '请输入正确的退货数量', type: 'warning' });
          return;
        }
      }

      this.tableData.push({
        ...row,
        RETURN_FEE: Number(row.RETURN_COUNT) * Number(row.PRODUCT_PRICE),
      });
    },
    checkReturnCount(row) {
      if (util.JudgmentUnit(row.TYPE_UNIT)) {
        if (!validation.数量正数验证(row.RETURN_COUNT)) {
          this.$message.show({ text: '请输入正确的退货数量', type: 'warning' });
          row.RETURN_COUNT = '';
          return;
        }
      } else {
        if (!validation.数量整数正数验证(row.RETURN_COUNT)) {
          this.$message.show({ text: '请输入正确的退货数量', type: 'warning' });
          row.RETURN_COUNT = '';
          return;
        }
      }
      if (Number(row.RETURN_COUNT) > Number(row.PRODUCT_COUNT)) {
        this.$message.show({ text: '退货数量不得大于剩余库存', type: 'warning' });
        row.RETURN_COUNT = '';
        return;
      }
      row.RETURN_FEE = Number(row.RETURN_COUNT) * Number(row.PRODUCT_PRICE);
    },
    submitOrder() {
      const params = {
        SERVICE_ID: '10057',
        OTYPE: 6,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        WAREHOUSE_MODE: this.WAREHOUSE_MODE,
        PRODUCT_ARRAY: this.tableData.map(({
          PRODUCT_CODE, BATCH, LOCATION_CODE, RETURN_REASON, RETURN_COUNT, ORDER_ID,
        }) => ({
          PRODUCT_CODE, BATCH, LOCATION_CODE, RETURN_REASON, PRODUCT_COUNT: RETURN_COUNT, ORDER_ID,
        })),
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '录入成功', type: 'success' });
        this.$router.go(-1);
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    deselect(index) {
      this.tableData.splice(index, 1);
    },
  },
};
</script>
<style scoped>
.footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}

ul {
  list-style: none;
  min-height: 5px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

.el-row {
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/tableManage/enterPurchaseReturnOrder.vue